'use client';

import { useIntl } from 'react-intl';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import type { ArticleServicesCurrencyFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesCurrencyFragmentDoc';
import { ArticleServicesFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesFragmentFragmentDoc';
import { articleServicesMessages } from './messages';
import { ArticleServicesCluster } from './ArticleServicesCluster';
import { BadgeDV } from '../BadgeDV';

/* GraphQL */ `
  fragment ArticleServicesFragment on APlus {
    clusters {
      ...ArticleServicesClusterFragment
    }
  }
`;

export type ArticleServicesProps = {
  data: FragmentType<typeof ArticleServicesFragmentFragmentDoc>;
  /* should be in aPlus price value */
  currencyData: FragmentType<typeof ArticleServicesCurrencyFragmentDoc>;
};

export const ArticleServices = ({ data, currencyData }: ArticleServicesProps) => {
  const { clusters } = getFragmentData(ArticleServicesFragmentFragmentDoc, data);

  const { formatMessage } = useIntl();

  if (clusters.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader hasDivider>
        <div>
          <BadgeDV text={formatMessage(articleServicesMessages.articleServicesCardTip)} />
          <span className="text-size-h5 pl-2">
            {formatMessage(articleServicesMessages.articleServicesCardHeadline)}
          </span>
        </div>
      </CardHeader>
      <CardContent className="pb-2">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {clusters.map(
            (cluster, idx) =>
              cluster && (
                <ArticleServicesCluster
                  data={cluster}
                  currencyData={currencyData}
                  key={JSON.stringify(cluster)}
                  isLastCluster={clusters.length - 1 === idx}
                />
              ),
          )}
        </form>
      </CardContent>
    </Card>
  );
};
